import React from "react";

const MetabotLogo = () => (
  <img className="brand-hue" src="app/assets/img/metabot.svg" />
);

export default MetabotLogo;
